import type { HttpUseFetchOptions } from '~/plugins/http/types';

let httpInstance: HttpUseFetchOptions<any> = null;

export function setHttp(instance: HttpUseFetchOptions<any>) {
	httpInstance = instance;
}

export function request<T>(options?: any): Promise<T> {
	if (!httpInstance) {
		throw new Error('HTTP client not initialized');
	}

	const method = (options.method || 'POST').toUpperCase();
	const op: any = {
		method,
		body: undefined,
		params: undefined,
		headers: options.header || undefined,
	};
	if (method === 'POST') {
		op.params = options.params;
		op.body = options.body || options.data || undefined;
	} else {
		op.params = options.params || options.data || undefined;
	}
	return httpInstance<T>(options.url, op);
}
